import { Component, Input, OnDestroy, OnInit, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { BaseAsideDataInterface } from '../../_interfaces/base-aside-data.interface';
import { BaseButtonSize } from '../../../../shared/components/button/base-button.component';
import { BaseLanguageSwitchColors } from '../../../../shared/enums/base-language-switch-colors.enum';
import { BASE_ASIDE_MODEL } from '../../_models/base-aside.model';
import { BaseAppRoutes } from '../../../../shared/constants/base-app-routes';
import { PORTAL_SETTINGS } from '../../../../core/token/base-config.token';
import { PortalSettings } from '../../../../core/types/base-portal-settings.type';

@Component({
  selector: 'base-auth-wrapper',
  templateUrl: './base-auth-wrapper.component.html',
})
export class BaseAuthWrapperComponent implements OnInit, OnDestroy {
  @Input() logo = 'assets-global/images/stazzle-logo-white.svg';
  asideData: BaseAsideDataInterface | undefined;
  buttonSize = BaseButtonSize;
  colors = BaseLanguageSwitchColors;
  isRegisterPage: boolean;

  private destroy$ = new Subject();

  constructor(private router: Router, @Inject(PORTAL_SETTINGS) private portalConfig: PortalSettings) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event) => {
        const navEndEvent = event as NavigationEnd;
        this.asideData = this.checkAuthUrl(navEndEvent.urlAfterRedirects);
      });
  }

  get portalSettings(): PortalSettings {
    return this.portalConfig;
  }

  ngOnInit() {
    this.checkAuthPage(this.router.url);

    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event) => {
        this.checkAuthPage((event as NavigationEnd).url);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  goTo(link: string | undefined): void {
    if (!link) {
      return;
    }

    window.open(link, '_blank');
  }

  checkAuthPage(url: string): void {
    this.isRegisterPage = url.indexOf(BaseAppRoutes.register) > -1;
  }

  checkAuthUrl(url: string): BaseAsideDataInterface {
    if (url.startsWith(BaseAppRoutes.register) || url.startsWith(BaseAppRoutes.invite)) {
      return BASE_ASIDE_MODEL.registration;
    } else if (url.startsWith(BaseAppRoutes.emasters)) {
      return BASE_ASIDE_MODEL.emasters;
    } else {
      return BASE_ASIDE_MODEL.login;
    }
  }

  trackByLink(_: number, item: string) {
    return item;
  }
}
